import { isEmpty } from 'lodash';

// import { sleep } from '../components/problems/FetchProblems';

export function to(promise) {
    /*     return sleep(5000)
            .then(() => promise)
            .then((data) => [null, data])
            .catch((err) => [err, undefined]); */

    return promise.then((data) => [null, data]).catch((err) => [err, undefined]);
}

const UNKNOWN_ERROR = 'Unknown error';
export function getErrMessage(err) {
    if (!isEmpty(err?.responseBody?.message)) {
        return err.responseBody.message;
    }

    if (!isEmpty(err?.response?.statusText)) {
        return `${err.response.status} - ${err.response.statusText}`;
    }

    return UNKNOWN_ERROR;
}
